export const getParams = (params: any) => {
    const queryParams = Object.entries(params)
        .filter(([key, value]) => !!value)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    return queryParams ? `?${queryParams}` : '';
};